<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
html,
body,
.page {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    transition: all .6s cubic-bezier(.5, .2, .2, 1.1);
    -webkit-transition: all .6s cubic-bezier(.5, .2, .2, 1.1);
    -moz-transition: all .6s cubic-bezier(.5, .2, .2, 1.1);
    -o-transition: all .6s cubic-bezier(.5, .2, .2, 1.1);
    color: #fff;
    overflow: hidden;
}

#menu .icon {
    color: #fff;
    font-size: 32px;
    display: block;
    margin: 30px 0;
    transition: all .5s ease-out !important;
    -webkit-transition: all .5s ease-out;
    -moz-transition: all .5s ease-out;
    -o-transition: all .5s ease-out;
}

.page {
    position: absolute;
}

#p1 {
    left: 0;
}

#p2 {
    left: 200%;
    background: #42d3a2;
}

#p3 {
    left: 200%;
    background: #e79252;
}

#p4 {
    left: 200%;
    background: #990099;
}

#p5 {
    left: 200%;
    background: #C0C0C0;
}

#s2:target #p2,
#s3:target #p3,
#s4:target #p4,
#s5:target #p5 {
    transform: translateX(-190%);
    -webkit-transform: translateX(-190%);
    -moz-transform: translateX(-190%);
    -o-transform: translateX(-190%);
    transition-delay: .2s !important;
}

#s2:target #p1,
#s3:target #p1,
#s4:target #p1,
#s5:target #p1 {
    background: black;
}

#s2:target #p1 .icon,
#s3:target #p1 .icon,
#s4:target #p1 .icon,
#s5:target #p1 .icon {
    -webkit-filter: blur(3px);
}

#s2:target ul .icon,
#s3:target ul .icon,
#s4:target ul .icon,
#s5:target ul .icon {
    transform: scale(.6);
    -webkit-transform: scale(.6);
    -moz-transform: scale(.6);
    -o-transform: scale(.6);
    transition-delay: .25s;
}

#s2:target #user,
#s3:target #skill,
#s4:target #project,
#s5:target #game {
    transform: scale(1.2) !important;
    -webkit-transform: scale(1.2) !important;
    -moz-transform: scale(1.2) !important;
    -o-transform: scale(1.2) !important;
}

ul .icon:hover {
    opacity: 0.5;
}

.page .homeIcon .title,
.homeTitle .icon {
    line-height: 2;
}

ul {
    position: fixed;
    z-index: 1;
    top: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    height: 280px;
    width: 10%;
    padding: 0;
    text-align: center;
}

a {
    text-decoration: none;
    color: white;
}

.c-article__title {
  color: #eee;
  text-shadow: 0 .05em rgba(0,0,0,0.17), 0 0.1em .25em rgba(0,0,0,0.25);
  font-weight: 900;
  background-position: 50% 50%;
  background-size: 95vw 80vw ;
}

.title,
.subtitle,
.homeTitle,
.aboutTitle {
    display: block;
}

.homeTitle {
    font-size: 52px;
    white-space: nowrap;
    transform: translateX(-22%);
    margin-bottom: 30px;
}

.aboutTitle {
    font-size: 40px;
    white-space: nowrap;
}

.subtitle {
    font-size: 16px;
    line-height: 20px;
    font-weight: 300;
}

.page .icon {
    position: absolute;
    top: -10%;
    bottom: 0;
    right: 0;
    left: 0;
    width: 270px;
    height: 170px;
    margin: auto;
    text-align: center;
    font-size: 80px;
    line-height: 1.3;
}

.page .icon2 {
    position: absolute;
    top: -10%;
    bottom: 0;
    right: 10%;
    left: 0;
    width: 270px;
    height: 170px;
    margin: auto;
    text-align: center;
    font-size: 78px;
    line-height: 1.3;
}

.page#p1 .page#p2 .icon {
    height: 220px;
}

.page#p1 .page#p2 .page#p3 .page#p4 .page#p5 .icon {
    transform: translateX(10%) !important;
}

.title {
    position: absolute;
    top: 0;
    bottom: 25%;
    right: 10%;
    left: 0;
    width: 270px;
    height: 170px;
    margin: auto;
    text-align: center;
    font-size: 52px;
    line-height: 1.3;
}

.block {
    width: inherit;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    margin: 42px 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
}

.block span,
.block span i {
    margin: 0 60px;
}

.skillblock {
    width: inherit;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    margin: 42px 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
}

.skillblock span,
.skillblock span i {
    margin: 0 54px;
}

.subicon {
    font-size: 32px;
}

.overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
    transition: opacity 500ms;
    visibility: hidden;
    opacity: 0;
}

.overlay:target {
    visibility: visible;
    opacity: 1;
}

.popup {
    padding: 20px;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 5px;
    width: 30%;
    height: 250px;
    position: absolute;
    transition: all 5s ease-in-out;
    margin: auto;
}

.popup h2 {
    margin-top: 0;
    color: #333;
}

.popup .close {
    position: absolute;
    top: 20px;
    right: 30px;
    transition: all 200ms;
    font-size: 30px;
    font-weight: bold;
    text-decoration: none;
    color: #333;
}

.popup .close:hover {
    color: #06D85F;
}

.popup .content {
    overflow: auto;
    color: black;
}
</style>
<template>
  <div class="slide" id="s1">
    <div class="slide" id="s2">
      <div class="slide" id="s3">
        <div class="slide" id="s4">
          <div class="slide" id="s5">
            <ul id="menu">
              <a href="#s1"><li class="icon fa fa-home" id="home"></li></a>
                <a href="#s2"><li class="icon fa fa-user" id="user"></li></a>
                <a href="#s3"><li class="icon fa fa-code" id="skill"></li></a>
                <a href="#s5"><li class="icon fa fa-gamepad" id="game"></li></a>
            </ul>
            <div class="page" id="p1">
              <section class="icon">
                  <span class="homeTitle">
                    <img src="../assets/logo.png" alt="Vinayak Logo" style="margin-left:50%;" >
                    <br />
                    <span class="c-article__title">Vinayak Kulkarni</span>
                  </span>
                  <span class="subtitle">Web Developer  <br> <br>
                  <a href="mailto:vinayak.kulkarni@live.com">{{ email }}</a></span>
              </section>
            </div>
            <div class="page" id="p2">
              <section class="icon2 fa fa-user"><span class="aboutTitle">About Me</span>
                <div class="block">
                  <span><i class="subicon fa fa-graduation-cap"></i><br/><strong>University of Pune</strong><br/>Masters in Computer Science</span>
                  <span><i class="subicon fa fa-soccer-ball-o"></i><br/><strong>Arsenal</strong><br/>Come on you Gooners!</span>
                  <span><i class="subicon fa fa-github"></i><br/><strong>GitHub</strong><br/><a href="https://github.com/vinayakkulkarni">Checkout my GitHub Profile</a></span>
                  <span><i class="subicon fa fa-map-marker"></i><br/><strong>Bangalore, KA</strong><br/>India</span>
                </div>
              </section>
            </div>
            <div class="page" id="p3">
              <section class="icon2 fa fa-code"><span class="aboutTitle">Skills</span>
                <div class="skillblock">
                  <span>
                    <i class="subicon fa fa-globe"></i><br/><strong>Web Development</strong><br/>HTML, CSS
                    <br/>VueJS 💕
                    <br/>Semantic-UI, jQuery, Vanilla JS
                    <br/>Laravel
                    <br/>AngularJS, ionic
                  </span>
                  <span>
                    <i class="subicon fa fa-laptop"></i><br/><strong>Software Development</strong><br/>JSON
                  </span>
                  <span>
                    <i class="subicon fa fa-database"></i><br/><strong>Database Management</strong>
                    <br/>MySQL, Oracle
                    <br/>MongoDB, Firebase
                  </span>
                  <span>
                    <i class="subicon fa fa-folder"></i><br/><strong>Miscellaneous</strong><br/>NPM
                    <br/>Cordova, AngularJS
                    <br/>Ionic, Bootstrap
                    <br/>Materialize, Git
                  </span>
                </div>
              </section>
            </div>
            <div class="page" id="p5">
              <section class="icon2 fa fa-gamepad"><span class="aboutTitle">Coming Soon!</span>
                <div class="block"></div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hello',
  data () {
    return {
      email: 'vinayak.kulkarni@live.com'
    }
  }
}
</script>



// WEBPACK FOOTER //
// Hello.vue?11c072fd